import Splide from '@splidejs/splide';
import { openTeamModal } from './team-modal-helpers';
window.openTeamModal = openTeamModal

const teamModals = document.getElementsByClassName('team-modal');

if (!teamModals) {
  return
}

Array.from(teamModals).forEach((teamModalEl) => {

  const modalSlider = teamModalEl.querySelector('.team-modal__slider');

  // Initialise and mount our slider
  const splideOptions = {
    useIndex: true,
    type: 'fade',
    rewind: true,
    speed: 500,
    pagination: false,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    perPage: 1
  }

  const teamModalSlider = new Splide( modalSlider, splideOptions);

  // Mount the slider
  teamModalSlider.mount();

  // Store the splide instance against the modal so we can easily hook in
  teamModalEl.splideInstance = teamModalSlider;

});